/**
 * Validation de la robustesse des mots de passe
 * Règles : 12 chars min, 1 maj, 1 min, 1 chiffre, 1 caractère spécial
 */
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{12,}$/;

export const PASSWORD_HINT = '12 caractères min., 1 majuscule, 1 minuscule, 1 chiffre, 1 caractère spécial';

export const validatePassword = (password: string): string | null => {
  if (!PASSWORD_REGEX.test(password)) {
    return `Mot de passe trop faible — ${PASSWORD_HINT}`;
  }
  return null;
};
